import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useNotificacao } from "../context/NotificacaoContext";
import "../assets/styles/Page.css";

function CompanyRegister() {
    const navigate = useNavigate();
    const { signupCompany } =  useAuth();
    const { mostrarNotificacao } = useNotificacao();
    const [form, setForm] = useState({ nome: "", telefone: ""});

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await signupCompany({ ...form, phoneNumberId: form.telefone, assistantId: "", token: "", nomeAtendente: "", perfilAtendente: ""});
            mostrarNotificacao("Empresa cadastrada!", "success");
            navigate("/dashboard");
        } catch (err) {
            if (err.response) {
            if (err.response.status === 500) {
                mostrarNotificacao("Ops! Tivemos um problema no servidor. Tente novamente em instantes.", "error");
                return;
            } else {
                mostrarNotificacao(err.response.data?.message || "Erro no cadastro", "error");
            }
            }
            mostrarNotificacao("Falha de conexão", "error");
        }
    };


    return (
        <div className="page">
            <div className="page-box">
            <h2>Cadastro</h2>
            <h3>Informe os dados da sua empresa</h3>
            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    placeholder="Nome"
                    value={form.nome}
                    onChange={(e) => setForm({ ...form, nome: e.target.value })}
                    required
                />
                <input
                    type="text"
                    placeholder="Telefone"
                    value={form.telefone}
                    onChange={(e) => setForm({ ...form, telefone: e.target.value })}
                    required
                />
                <button type="submit">Cadastrar</button>
                <button className="btn-voltar" onClick={() => navigate("/cadastro")}>
                    Voltar
                </button>
            </form>
            </div>
        </div>    
    )
}

export default CompanyRegister;
